import { render, staticRenderFns } from "./income-detail-modal.vue?vue&type=template&id=10e9999a"
import script from "./income-detail-modal.vue?vue&type=script&lang=js"
export * from "./income-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports